// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60fb2837","455":"292a73c6","977":"72e3ccd7"}[chunkId] + ".chunk.js";
};